import React, { useEffect, useRef, useState } from 'react';
// import './slider.scss';
const windowObj = typeof window === 'undefined' ? {} : window;
const isTouchScreen = 'ontouchstart' in windowObj;
const moveEvent = isTouchScreen ? 'touchmove' : 'mousemove';
const upEvent = isTouchScreen ? 'touchend' : 'mouseup';
export function Slider({ onChange, value, snap, from, to, step = 1, instant }) {
    const intervalsLength = (to - from) / step;
    const intervals = new Array(intervalsLength + 1).fill(null).map((_, index) => step * index + from);
    const [barPos, setBarPos] = useState(interpolate(value || 0, from, to, 0, 100));
    const [isTracking, setIsTracking] = useState(false);
    const trackRef = useRef(null);
    const barRef = useRef(null);
    const trackLeft = useRef(0);
    const trackWidth = useRef(0);
    const onDragStart = (event) => {
        var _a;
        if (!trackRef.current)
            return;
        if (!barRef.current)
            return;
        event.stopPropagation();
        const clientX = getClientX(event);
        const { left, width } = (_a = trackRef === null || trackRef === void 0 ? void 0 : trackRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        trackLeft.current = left;
        trackWidth.current = width;
        const percentOffset = getBarOffset(clientX, trackLeft, trackWidth);
        setBarPos(percentOffset);
        if (instant) {
            let percent = percentOffset;
            if (snap) {
                percent = findNearestInterval(percentOffset, 100 / (intervals.length - 1));
            }
            let realVal = roundToDecimal(interpolate(percent, 0, 100, from, to), 5);
            onChange && onChange(realVal, percent);
        }
        document.body.classList.add('--grabbing');
        document.addEventListener(moveEvent, onDragMove);
        document.addEventListener(upEvent, onDragEnd);
        setIsTracking(true);
    };
    const onDragMove = (event) => {
        const clientX = getClientX(event);
        const percentOffset = getBarOffset(clientX, trackLeft, trackWidth);
        setBarPos(percentOffset);
        if (instant) {
            let percent = percentOffset;
            if (snap) {
                percent = findNearestInterval(percentOffset, 100 / (intervals.length - 1));
            }
            let realVal = roundToDecimal(interpolate(percent, 0, 100, from, to), 5);
            onChange && onChange(realVal, percent);
        }
    };
    const onDragEnd = () => {
        document.body.classList.remove('--grabbing');
        document.removeEventListener(moveEvent, onDragMove);
        document.removeEventListener(upEvent, onDragEnd);
        setIsTracking(false);
    };
    useEffect(() => {
        return () => {
            onDragEnd();
        };
    }, []);
    useEffect(() => {
        if (isTracking)
            return;
        if (!snap) {
            onChange && onChange(interpolate(barPos, 0, 100, from, to), barPos);
            return;
        }
        const nearestInterval = findNearestInterval(barPos, 100 / (intervals.length - 1));
        setBarPos(nearestInterval);
        const realVal = roundToDecimal(interpolate(nearestInterval, 0, 100, from, to), 5);
        onChange && onChange(realVal, nearestInterval);
    }, [isTracking]);
    useEffect(() => { setBarPos(interpolate(value || 0, from, to, 0, 100)); }, [value]);
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: "ltg-slider-wrap" },
            React.createElement("div", { className: "ltg-slider-track", ref: trackRef, onMouseDown: onDragStart, onTouchStart: onDragStart },
                React.createElement("div", { className: "ltg-slider-fill", style: { right: `${100 - barPos}%` } }),
                React.createElement("div", { className: "ltg-slider-bar", ref: barRef, style: { left: `${barPos}%` } }))));
}
function getBarOffset(clientX, trackLeft, trackWidth) {
    let offset;
    if (clientX > trackLeft.current + trackWidth.current) {
        offset = trackWidth.current;
    }
    else {
        offset = clientX - trackLeft.current;
    }
    if (offset < 0) {
        offset = 0;
    }
    const percentOffset = Math.round(offset / trackWidth.current * 100);
    return percentOffset;
}
function findNearestInterval(value, intervalSize) {
    const val = Math.floor(value / intervalSize * 10) / 10;
    let valInteger = Math.floor(val);
    const valDecimal = val - valInteger;
    if (valDecimal >= .5) {
        valInteger++;
    }
    return valInteger * intervalSize;
    // return Math.floor(value / intervalSize) * 100
}
function roundToDecimal(value, decimalPlace) {
    if (!decimalPlace)
        return Math.round(value);
    return Math.round(value * Math.pow(10, decimalPlace)) / Math.pow(10, decimalPlace);
}
function getClientX(event) {
    if ('touches' in event) {
        // Touch event
        return event.touches[0].clientX;
    }
    else {
        // Mouse event
        return event.clientX;
    }
}
export function interpolate(value, min1, max1, min2, max2) {
    // Calculate the percentage of the input value relative to the input range
    var percent = (value - min1) / (max1 - min1);
    // Calculate the output value based on the percentage and output range
    var result = percent * (max2 - min2) + min2;
    // Return the output value
    return result;
}
